import { Flex, Table } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import axiosInstance from "../../axios";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

dayjs.extend(utc);
dayjs.extend(timezone);

const IST = "Asia/Kolkata";

const CancelReasonTabRender = ({ studentDetails }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 200,
  });
  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
  }, []);

  const fetchData = async (page, limit) => {
    console.log("fetching data", Number(studentDetails.userId));
    setLoading(true);
    const response = await axiosInstance.get(`/v1/cre/close-request`, {
      params: {
        userId: Number(studentDetails?.userId),
        page,
        limit,
      },
    });
    setData(
      response.data.data?.map((item) => ({
        ...item,
        fullName: `${item.first_name} ${item.last_name}`,
        createdAt: dayjs.utc(item.created_at).tz(IST).format("DD-MM-YYYY HH:mm:ss"),
      }))
    );
    setPagination({
      ...pagination,
      current: page,
      pageSize: limit,
      total: response.data.meta.total,
    });
    setLoading(false);
  };

  const columns = [
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 200,
    },
    {
      title: "Reason",
      dataIndex: "request_value",
      key: "request_value",
    },
  ];

  const handleTableChange = (pagination, filters, sorter) => {
    if (pagination.current) {
      fetchData(pagination.current, pagination.pageSize);
    }
  };

  return (
    <Flex
      style={{
        overflow: "scroll",
        marginLeft: "5px",
      }}
    >
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{
          ...pagination,
          onChange: handleTableChange,
          showSizeChanger: true,
          pageSizeOptions: [10, 15, 20, 25, 50, 100, 150, 200, 250, 500],
        }}
        loading={loading}
        onChange={handleTableChange}
      />
    </Flex>
  );
};

CancelReasonTabRender.propTypes = {
  studentDetails: PropTypes.shape({
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
};

export default CancelReasonTabRender;
